// Mock data for Inpace Power Solar Proposal Software

export const COMPANY = {
  name: 'INPACE POWER',
  tagline: 'Powered by Our People',
  description: 'A passionate in-house team of certified engineers and technicians delivering end-to-end solar rooftop solutions across Bangalore.',
  phone: '+91 86181 96685',
  director: 'Santhosha Kumar R',
  address: 'Bangalore, Karnataka, India',
  email: 'sales@inpacepowers.com',
  website: 'inpacepowers.com',
  gstin: '29ABCDE1234F1Z5',
};

export const STATS = [
  { label: 'Residential Installations', value: '224+' },
  { label: 'Commercial Projects', value: '10+' },
  { label: 'Industrial Plants (200kW+)', value: '8' },
  { label: 'Years Experience', value: '3+' },
];

export const TRUSTED_LOGOS = [
  'Tata Power', 'Adani', 'Waaree', 'Vikram Solar', 'Luminous', 'Loom Solar', 'Panasonic', 'Polycab', 'Havells', 'Schneider', 'Microtek', 'Su-Kam'
];

export const FEATURES = [
  { icon: 'Leaf', title: 'Non-Polluting', desc: 'Zero emissions during power generation — a clean source for your home & business.' },
  { icon: 'Wrench', title: 'Easy Installation', desc: 'Most rooftops are commissioned in under 7 days with minimal civil work.' },
  { icon: 'Sun', title: 'Renewable Energy', desc: 'Limitless sunlight is converted into usable electricity all day, every day.' },
  { icon: 'Sprout', title: 'Clean & Green', desc: 'A tonne of CO₂ is avoided every year for every 1 kW you install.' },
  { icon: 'Settings', title: 'Solar Maintenance', desc: 'Annual maintenance contracts that keep your system at peak efficiency.' },
  { icon: 'IndianRupee', title: 'Easy Financing', desc: 'EMI options, CAPEX & OPEX models tailored for every budget.' },
];

export const SECTORS = [
  { count: '224', label: 'Installations', title: 'Residential Sector', desc: 'Homes powered across Bangalore and surrounding areas.', img: 'https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?w=800&q=80' },
  { count: '10', label: 'Projects', title: 'Commercial Sector', desc: 'Offices, showrooms and retail spaces running on solar.', img: 'https://images.unsplash.com/photo-1542336391-ae2936d8efe4?w=800&q=80' },
  { count: '8', label: 'Plants (200kW+)', title: 'Industrial Sector', desc: 'Large-scale factory rooftops, each over 200 kW capacity.', img: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?w=800&q=80' },
];

export const SERVICES = [
  { title: 'Rooftop Selection Criteria', desc: 'We evaluate RCC, asbestos or sheet metal roofs for orientation, shadow-free area and structural load.', img: 'https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e?w=800&q=80' },
  { title: 'Solar Panel Maintenance', desc: 'Annual maintenance contracts, panel cleaning, inverter health checks & remote monitoring.', img: 'https://images.unsplash.com/photo-1660330589505-9a433a742a7b?w=800&q=80' },
  { title: 'CAPEX Model', desc: 'Own your plant outright — best returns, accelerated depreciation and full ownership of generated power.', img: 'https://images.unsplash.com/photo-1542336391-ae2936d8efe4?w=800&q=80' },
  { title: 'OPEX / RESCO Model', desc: 'Zero capital investment — pay only for the units consumed under a long-term PPA.', img: 'https://images.unsplash.com/photo-1559302504-64aae6ca6b6d?w=800&q=80' },
  { title: 'On-Grid Systems', desc: 'Grid-tied inverters with net-metering — surplus power is exported to BESCOM.', img: 'https://images.unsplash.com/photo-1660330589257-813305a4a383?w=800&q=80' },
  { title: 'Off-Grid & Hybrid', desc: 'Battery backed systems for uninterrupted power in remote and load-shedding zones.', img: 'https://images.unsplash.com/photo-1660330589243-4c640d878052?w=800&q=80' },
];

export const PROCESS = [
  { step: '01', title: 'Site Survey', desc: 'Free rooftop survey, shadow analysis and load assessment.' },
  { step: '02', title: 'Custom Design', desc: 'Engineered single-line diagrams, BOQ and ROI projections.' },
  { step: '03', title: 'Installation', desc: 'Certified crews complete installation in under 7 days.' },
  { step: '04', title: 'Net-Metering', desc: 'We handle BESCOM approvals and commissioning end-to-end.' },
];

export const TESTIMONIALS = [
  { name: 'Vikranth', role: 'Banashankari, Bangalore', text: 'We appreciate the quality of material supplied and the level of service provided by the dedicated team from Inpace Power for the solar PV system installed at my residence.' },
  { name: 'Ramya S', role: 'JP Nagar, Bangalore', text: 'Got a 5kW system installed in 6 days. The savings are real and the team’s post-installation support has been exceptional.' },
  { name: 'Arvind Mehta', role: 'Director, MetalCraft Industries', text: 'Our 250kW industrial plant has paid back in under 4 years. Inpace handled every BESCOM formality without us lifting a finger.' },
];

// Sales tool data
export const DEFAULT_USER = {
  id: 'sales-001',
  name: 'Santhosh K',
  email: 'sales@inpacepowers.com',
  role: 'Sales Executive',
  avatar: 'SK',
};

export const LEADS = [
  { id: 'L-1001', name: 'Rohit Sharma', phone: '+91 98450 12345', city: 'Bangalore', segment: 'Residential', kw: 5, status: 'Hot', source: 'Website', createdAt: '2025-07-12' },
  { id: 'L-1002', name: 'Krishna Textiles', phone: '+91 98860 22112', city: 'Mysuru', segment: 'Industrial', kw: 250, status: 'Negotiation', source: 'Referral', createdAt: '2025-07-10' },
  { id: 'L-1003', name: 'Aditi Rao', phone: '+91 97400 88412', city: 'Bangalore', segment: 'Residential', kw: 3, status: 'New', source: 'JustDial', createdAt: '2025-07-14' },
  { id: 'L-1004', name: 'GreenLeaf Cafe', phone: '+91 99000 33421', city: 'Hubli', segment: 'Commercial', kw: 25, status: 'Proposal Sent', source: 'Walk-in', createdAt: '2025-07-09' },
  { id: 'L-1005', name: 'Anil Kumar', phone: '+91 98801 76543', city: 'Tumakuru', segment: 'Residential', kw: 8, status: 'Hot', source: 'Facebook', createdAt: '2025-07-15' },
  { id: 'L-1006', name: 'Sunrise Hospital', phone: '+91 98860 12321', city: 'Bangalore', segment: 'Commercial', kw: 60, status: 'New', source: 'Google Ads', createdAt: '2025-07-15' },
];

export const PROPOSALS = [
  { id: 'P-2025-101', leadId: 'L-1004', customer: 'GreenLeaf Cafe', kw: 25, totalCost: 1387500, savings: 4250000, payback: 4.2, status: 'Sent', date: '2025-07-11' },
  { id: 'P-2025-100', leadId: 'L-1002', customer: 'Krishna Textiles', kw: 250, totalCost: 12500000, savings: 48000000, payback: 3.6, status: 'Won', date: '2025-07-10' },
];

// Pricing per kW (mock, all-inclusive INR)
export const PRICING = {
  Residential: { perKw: 62000, subsidy: { 1: 30000, 2: 60000, 3: 78000 } },
  Commercial:  { perKw: 55500, subsidy: {} },
  Industrial:  { perKw: 50000, subsidy: {} },
};

// State average tariff per unit (INR)
export const TARIFF = {
  Residential: 8.5,
  Commercial: 11.0,
  Industrial: 9.8,
};

// Generation factor: units per kW per day (Bangalore ≈ 4.2)
export const GENERATION_FACTOR = 4.2;

// Default panel & inverter library
export const PANEL_LIBRARY = [
  { id: 'WAAREE-540', brand: 'Waaree', model: 'Aditya 540W Mono PERC', wattage: 540, price: 14500 },
  { id: 'TATA-450', brand: 'Tata Power Solar', model: 'TP450 Mono PERC', wattage: 450, price: 12500 },
  { id: 'VIKRAM-535', brand: 'Vikram Solar', model: 'Somera 535W', wattage: 535, price: 14000 },
];

export const INVERTER_LIBRARY = [
  { id: 'GW-5K', brand: 'Goodwe', model: '5kW On-Grid', kw: 5, price: 42000 },
  { id: 'SF-10K', brand: 'Sungrow', model: '10kW Three-Phase', kw: 10, price: 75000 },
  { id: 'FX-25K', brand: 'Fronius', model: 'Symo 25kW', kw: 25, price: 185000 },
  { id: 'HV-50K', brand: 'Huawei', model: 'SUN2000 50kW', kw: 50, price: 320000 },
];

export function calcProposal({ kw, segment }) {
  const pricing = PRICING[segment] || PRICING.Residential;
  const tariff = TARIFF[segment] || 8.5;
  const grossCost = kw * pricing.perKw;
  const subsidyTable = pricing.subsidy || {};
  let subsidy = 0;
  if (segment === 'Residential') {
    if (kw <= 1) subsidy = subsidyTable[1] || 0;
    else if (kw <= 2) subsidy = subsidyTable[2] || 0;
    else subsidy = subsidyTable[3] || 78000;
  }
  const netCost = Math.max(0, grossCost - subsidy);
  const dailyUnits = kw * GENERATION_FACTOR;
  const yearlyUnits = Math.round(dailyUnits * 365);
  const yearlySavings = Math.round(yearlyUnits * tariff);
  const lifetimeYears = 25;
  const lifetimeSavings = yearlySavings * lifetimeYears;
  const payback = +(netCost / yearlySavings).toFixed(1);
  const co2 = Math.round(yearlyUnits * 0.82); // kg CO2 per unit avoided
  return { kw, grossCost, subsidy, netCost, yearlyUnits, yearlySavings, lifetimeSavings, payback, co2, tariff };
}

export function inr(n) {
  if (n === undefined || n === null || isNaN(n)) return '₹0';
  return '₹' + Number(n).toLocaleString('en-IN');
}
